import type { ProductType } from "@/api_client";
import { useProductNavigationHandlers } from "./useProductNavigationHandlers";

export const useNoopProductNavigationHandlers = () => ({
  goToEditProduct: (_productType?: ProductType, _productId?: string | null) => {
    return;
  },
  goToPricePage: (_productType?: ProductType, _productId?: string | null) => {
    return;
  },
});

// when we have an external submit handler we are not i a next context,
// in these cases we can't use the normal product navigation(not even call useProductNavigation)
// without throwing errors, because it relies on next router, so we use a noop navigation handler instead
export const getProductNavigationHook = (inNextContext: boolean) => {
  if (inNextContext) {
    return useProductNavigationHandlers;
  }
  return useNoopProductNavigationHandlers;
};
